export default "__VITE_ASSET__CA$MC6za__"